import { ModelMixin } from '../core/base-generic.model';
import { KycKybWave } from './kyc-kyb-wave.model';

export class CompanyKycKybWave extends ModelMixin<CompanyKycKybWave>() {
    protected static _version = 'v2';

    get companyId(): number {
        return this._attributes['companyId'];
    }

    get waveId(): number {
        return this._attributes['waveId'];
    }

    get hasVerifiedIndustry(): boolean {
        return this._attributes['hasVerifiedIndustry'];
    }

    get kycKybWave(): KycKybWave {
        return this.hasOne(KycKybWave, 'kycKybWave');
    }

    get hasWaveDefinition(): boolean {
        return this.kycKybWave != null;
    }
}
